import { Button, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material';
import DialogBaseCC from 'components/Dialog/DialogBaseCC';
import { DIALOG_ID } from 'components/Dialog/constant';
import { TypographyLink } from 'components/common/Typography';
import { useTranslation } from 'react-i18next';
import { goToLicenseStore } from 'utils/functions/common';
import { setCloseDialogCC } from 'utils/helpers';

const DialogWarningLicenseRoom = () => {
    const { t } = useTranslation();

    return (
        <DialogBaseCC id={DIALOG_ID.WARNING_LICENSE_ROOM} title={t('dialog.room.inviteMore')}>
            <DialogContent>
                <DialogContentText>
                    <Typography color={theme => theme.palette.text[700]}>{t('room.limited')}</Typography>
                    <Typography display={'flex'}>
                        {t('room.limitedUsers')} <TypographyLink sx={{ ml: 0.5 }} onClick={goToLicenseStore} labelKey={'room.here'} />
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={setCloseDialogCC}>
                    {t('dialog.cancel')}
                </Button>
                <Button onClick={setCloseDialogCC}>{t('dialog.understood')}</Button>
            </DialogActions>
        </DialogBaseCC>
    );
};

export default DialogWarningLicenseRoom;
